export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const DEFAULT_YEAR_RANGE = {
  start: 1990,
  end: new Date().getFullYear() + 20,
};
